import { setLoadIndicatorExchangeRate } from 'pages/requestForm/actions';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useGetCurrencyExchangeRate } from 'shared/data/webApp/v2';

import { getDateParam } from './ExchangeRateWithUpdate.helpers';
import { ExchangeRateWithUpdateProps } from './ExchangeRateWithUpdate.types';

export function useExchangeRateWithUpdate(props: ExchangeRateWithUpdateProps) {
    const { date, currency, requestId, companyId, companyCurrency, onChange } = props;

    const dispatch = useDispatch();

    const dateParam = getDateParam(date);
    const enabled = currency !== companyCurrency;

    const {
        data: currencyExchangeRate,
        isError: isErrorCurrencyExchangeRate,
        isSuccess: isSuccessCurrencyExchangeRate,
        isFetching: isFetchingCurrencyExchangeRate,
    } = useGetCurrencyExchangeRate(
        {
            path: {
                companyId,
                requestId,
            },
            query: {
                date: dateParam,
                currency,
            },
        },
        {
            enabled,
        }
    );

    const isLoadingActive = useRef(false);

    useEffect(() => {
        if (isFetchingCurrencyExchangeRate) {
            if (!isLoadingActive.current) {
                isLoadingActive.current = true;
                dispatch(setLoadIndicatorExchangeRate('start'));
            }
        } else if (isLoadingActive.current) {
            isLoadingActive.current = false;
            dispatch(setLoadIndicatorExchangeRate('stop'));
        }
    }, [enabled, dispatch, isFetchingCurrencyExchangeRate]);

    useEffect(
        () => () => {
            if (isLoadingActive.current) {
                isLoadingActive.current = false;
                dispatch(setLoadIndicatorExchangeRate('stop'));
            }
        },
        [dispatch]
    );

    useEffect(() => {
        if (isErrorCurrencyExchangeRate) {
            onChange?.({});
        }
    }, [isErrorCurrencyExchangeRate, onChange]);

    useEffect(() => {
        if (isSuccessCurrencyExchangeRate) {
            onChange?.({
                exchangeRate: currencyExchangeRate.exchangeRate,
                exchangeRateSource: currencyExchangeRate.source,
                exchangeRateDate: dateParam,
            });
        }
    }, [currencyExchangeRate, dateParam, isSuccessCurrencyExchangeRate, onChange]);

    return { currencyExchangeRate, dateParam };
}
